module.exports = __webpack_public_path__ + "img/SEGURIFY_GIF_AXA_200x644_270622.6f701499.gif";